import { Instagram, Facebook, Linkedin, Youtube, Globe, Music2, Mail, Phone, MapPin, User, Hash, Briefcase, Landmark, ShieldCheck, MessageCircle, Store, FileDigit } from "lucide-react";
import { Panel } from "@/components/core/AppLayout";

const Row = ({ icon: Icon, label, value, href, testid }) => (
  <div className="flex items-start gap-3 py-3 border-b border-slate-100 last:border-0" data-testid={testid}>
    <Icon className="h-4 w-4 text-[#0A1128] mt-0.5 shrink-0" />
    <div className="min-w-0">
      <div className="text-[11px] font-bold uppercase tracking-wider text-slate-400">{label}</div>
      {value ? (
        href ? <a href={href} target="_blank" rel="noreferrer" className="text-sm font-semibold text-[#0A1128] hover:text-[#E8173A] break-all">{value}</a>
             : <div className="text-sm font-semibold text-slate-800 break-words">{value}</div>
      ) : <div className="text-sm text-slate-400">—</div>}
    </div>
  </div>
);

const SOCIAL = [["instagram", "Instagram", Instagram], ["facebook", "Facebook", Facebook], ["linkedin", "LinkedIn", Linkedin], ["tiktok", "TikTok", Music2], ["youtube", "YouTube", Youtube]];

export const ClientAnagrafica = ({ client: c }) => (
  <div className="grid grid-cols-3 gap-6" data-testid="client-anagrafica">
    <Panel className="p-6 col-span-2">
      <h3 className="font-display text-lg font-extrabold text-[#0A1128] mb-2">Dati anagrafici</h3>
      <div className="grid grid-cols-2 gap-x-8">
        <Row icon={Briefcase} label="Ragione sociale" value={c.ragione_sociale} testid="anag-ragione-sociale" />
        <Row icon={User} label="Referente" value={c.referente} testid="anag-referente" />
        <Row icon={Mail} label="Email" value={c.email} href={c.email && `mailto:${c.email}`} testid="anag-email" />
        <Row icon={Phone} label="Telefono" value={c.telefono} href={c.telefono && `tel:${c.telefono}`} testid="anag-telefono" />
        <Row icon={Hash} label="P.IVA" value={c.piva} testid="anag-piva" />
        <Row icon={Briefcase} label="Settore" value={c.settore} testid="anag-settore" />
        <Row icon={MapPin} label="Indirizzo" value={c.indirizzo} testid="anag-indirizzo" />
        <Row icon={Globe} label="Sito web" value={c.sito_web} href={c.sito_web} testid="anag-sito" />
        <Row icon={User} label="Socio responsabile" value={c.socio_nome} testid="anag-socio" />
        <Row icon={MessageCircle} label="WhatsApp" value={c.whatsapp} href={c.whatsapp && `https://wa.me/${c.whatsapp.replace(/\D/g, "").replace(/^(?!39)/, "39")}`} testid="anag-whatsapp" />
      </div>
      <h3 className="font-display text-lg font-extrabold text-[#0A1128] mt-6 mb-2">Dati fiscali e amministrativi</h3>
      <div className="grid grid-cols-2 gap-x-8">
        <Row icon={FileDigit} label="Codice fiscale" value={c.codice_fiscale} testid="anag-codice_fiscale" />
        <Row icon={Hash} label="REA" value={c.rea} testid="anag-rea" />
        <Row icon={ShieldCheck} label="PEC" value={c.pec} href={c.pec && `mailto:${c.pec}`} testid="anag-pec" />
        <Row icon={Hash} label="Codice SDI" value={c.sdi} testid="anag-sdi" />
        <Row icon={User} label="Legale rappresentante" value={c.legale_rappresentante} testid="anag-legale" />
        <Row icon={Landmark} label="IBAN" value={c.iban && `${c.iban}${c.banca ? ` · ${c.banca}` : ""}`} testid="anag-iban" />
      </div>
      {(!!c.sedi?.length || !!c.siti?.length || !!c.insegne?.length) && (
        <div className="grid grid-cols-2 gap-x-8 mt-4">
          {!!c.sedi?.length && <div data-testid="anag-sedi"><div className="text-[11px] font-bold uppercase tracking-wider text-slate-400 mt-3 mb-1">Sedi</div>
            {c.sedi.map((s, i) => <Row key={i} icon={MapPin} label={s.etichetta || `Sede ${i + 1}`} value={s.indirizzo} testid={`anag-sede-${i}`} />)}</div>}
          {!!c.siti?.length && <div data-testid="anag-siti"><div className="text-[11px] font-bold uppercase tracking-wider text-slate-400 mt-3 mb-1">Siti web</div>
            {c.siti.map((s, i) => <Row key={i} icon={Globe} label={s.etichetta || `Sito ${i + 1}`} value={s.url} href={s.url} testid={`anag-sitoweb-${i}`} />)}</div>}
          {!!c.insegne?.length && <div className="col-span-2 mt-3" data-testid="anag-insegne"><div className="text-[11px] font-bold uppercase tracking-wider text-slate-400 mb-2">Insegne / brand</div>
            <div className="flex flex-wrap gap-2">{c.insegne.map((t) => <span key={t} className="inline-flex items-center gap-1 rounded-full bg-[#A6DAFC] px-3 py-1 text-xs font-bold text-[#0A1128]"><Store className="h-3 w-3" />{t}</span>)}</div></div>}
        </div>
      )}
      <div className="mt-5">
        <div className="text-[11px] font-bold uppercase tracking-wider text-slate-400 mb-2">Note</div>
        <div className="text-sm text-slate-700 whitespace-pre-wrap bg-slate-50 rounded-xl p-4 min-h-[60px]" data-testid="anag-note">{c.note || "Nessuna nota."}</div>
      </div>
    </Panel>
    <Panel className="p-6 h-fit">
      <h3 className="font-display text-lg font-extrabold text-[#0A1128] mb-2">Canali social</h3>
      {SOCIAL.map(([k, l, I]) => <Row key={k} icon={I} label={l} value={c[k]} href={c[k]} testid={`anag-${k}`} />)}
    </Panel>
  </div>
);
